export default __webpack_public_path__ + "static/media/cups.e46676dc.png";